import Styles from './Progress.module.scss';

const Progress = ({ style, value, ...props }) => {
  return (
    <div className={Styles.container} style={{ width: `${value}%`, ...style }} {...props}></div>
  );
};

export default Progress;
